import React, { useState } from "react";
import { validateEmail, validatePassword } from "../utils/validation";
import PasswordStrength from "./PasswordStrength";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "../styles/Signup.css";

const SignupForm = () => {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: ""
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    validateField(name, value);
  };

  const validateField = (name, value) => {

    let newErrors = { ...errors };

    if (name === "email") {
      newErrors.email = validateEmail(value)
        ? ""
        : "Invalid email";
    }

    if (name === "password") {
      newErrors.password = validatePassword(value)
        ? ""
        : "Weak password";
    }

    setErrors(newErrors);
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    if (!errors.email && !errors.password) {

      localStorage.setItem("user", JSON.stringify(formData));

      toast.success("Signup successful!");

      setTimeout(() => {
        navigate("/login");
      }, 1500);
    }
  };

  return (

    <div className="signup-container">

      <Toaster position="top-center"/>

      <form className="signup-form" onSubmit={handleSubmit}>

        <h2>Create Account</h2>

        <input
          type="text"
          name="name"
          placeholder="Full Name"
          onChange={handleChange}
        />

        <input
          type="email"
          name="email"
          placeholder="Email"
          onChange={handleChange}
        />

        {errors.email && <p className="error">{errors.email}</p>}

        <div className="password-box">

          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Password"
            onChange={handleChange}
          />

          <span
            className="toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? "Hide" : "Show"}
          </span>

        </div>

        {errors.password && <p className="error">{errors.password}</p>}

        <PasswordStrength password={formData.password} />

        <button type="submit">Signup</button>

        <p className="login-link">
          Already have an account?
          <span onClick={() => navigate("/login")}> Login</span>
        </p>

      </form>

    </div>
  );
};

export default SignupForm;